import React, { useContext, useState } from "react";
import { Input, Button, Form, Col, Row, message } from "antd";
import GlobalStatesContext from "../../../common/providers/GlobalStatesContext";
import ApiClient from "../../../helpers/ApiClient";

const PanVerification = (props) => {
  const {
    state: {
      otherData: { PanVerificationDetails },
    },
    PanVerification,
  } = useContext(GlobalStatesContext);
  const [panNumber, setPanNumber] = useState("");
  const [loading, setLoading] = useState(false);
  // const form = Form.useFormInstance();
   const form = Form.useFormInstance?.() || { setFieldsValue: () => {} };

  const INVALID_PAN_MESSAGE =
    "Wrong Pan Number, Please check and put actual PAN Number.";

  const reportVerifyError = (text = INVALID_PAN_MESSAGE) => {
    if (props.showInlineErrors && props.onVerifyError) {
      props.onVerifyError(text);
      return;
    }
    message.error(text);
  };

  const handlePanVerification = () => {
    props.onVerifyStart?.();
    if (panNumber.length !== 10) {
      reportVerifyError(INVALID_PAN_MESSAGE);
      return;
    }
    
    if(props.serviceType == 2) {
      PanVerification({
        pan_number: panNumber,
        roomIndex:props.roomIndex,
        paxIndex:props.paxIndex
      });
    }else{
      setLoading(true);
      const verifyPayload = { pan_number: panNumber };
      if (props.referenceNo) {
        verifyPayload.referenceNo = props.referenceNo;
      }
      ApiClient.post('hotels-v2/verificationPan/', verifyPayload).then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data?.[0]?.pan_number) {
          const row = res.data[0];
          const verifiedPan = row.pan_number;
          const verifiedName =
            String(row.pan_returned_name ?? "").trim() ||
            `${row.first_name ?? ""} ${row.last_name ?? ""}`.trim();
          props.setPanVerificationNumber?.(verifiedPan, verifiedName, {
            firstName: row.first_name,
            lastName: row.last_name,
            panReturnedName: row.pan_returned_name,
          });
          if (!props.showInlineErrors) {
            message.success({
              content: `${verifiedName} your ${res.message}`,
              duration: 2,
            });
          }
        } else {
          reportVerifyError(INVALID_PAN_MESSAGE);
        }
      }).catch((error) => {
        setLoading(false);
        console.error("Error: ", error);
        reportVerifyError(INVALID_PAN_MESSAGE);
       });
    }
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col md={16} sm={12} xs={12}>
          <Form.Item
            label="Pan Number"
            name={props.serviceType == 2 ? `pan_number${props.roomIndex}_${props.paxIndex}`: `pan_number` }
            // name={`pan_number${props.roomIndex}_${props.paxIndex}`}
            rules={[
              { required: props.serviceType == 2 ? true : false, message: "Required" },
              { len: 10, message: "PAN must be exactly 10 characters" },
              { pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, message: "Invalid PAN format" }
            ]}
          >
            <Input
              className="inputbg"
              placeholder="Enter Your Pan Number"
              autoComplete="off"
              maxLength={10}
              onInput={(e) => {
                e.target.value = e.target.value.toUpperCase();
              }}
              onChange={(e) => {
                const upperValue = e.target.value.toUpperCase();
                setPanNumber(upperValue);
                // Update form field value immediately
                const fieldName = props.serviceType == 2 ? `pan_number${props.roomIndex}_${props.paxIndex}` : `pan_number`;
                form.setFieldsValue({ [fieldName]: upperValue });
              }}
            />
          </Form.Item>
        </Col>

        <Col md={8} sm={12} xs={12}>
          <Form.Item>
            <Button
              className="mt-4"
              type="primary"
              loading={loading}
              onClick={handlePanVerification}
            >
              Apply
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default PanVerification;
